import React from 'react';
import { motion } from 'framer-motion';
import AboutInto from './about-intro.svg';

function Intro() {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#0a0a0a]">

      <div className="absolute 
        /* Desktop: 12deg rotate, Top setup */
        md:rotate-[12deg] md:-top-[35%] md:-left-[100px] md:right-0 md:h-[120%] 
        /* Mobile: Kam rotation taaki content na dabbe */
        rotate-[6deg] -top-[20%] -left-[50px] w-[150%] h-[100%]
        bg-[#ff4e00] bg-[linear-gradient(315deg,#ff4e00_0%,#ec9f05_74%)]
        rounded-[50px] z-0 shadow-2xl pointer-events-none transition-all duration-700">
      </div>

      <div className="relative z-10 container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center min-h-screen py-20 lg:py-0">

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center items-center order-2 lg:order-1"
        >
          <div className="relative group">
            <div className="absolute inset-0 bg-white/20 blur-[100px] rounded-full group-hover:bg-white/30 transition-all duration-500"></div>

            <img
              src={AboutInto}
              alt="Digital Canto"
              className="relative z-20 h-[280px] w-[280px] md:h-[450px] md:w-[450px] object-contain animate-float-slow drop-shadow-[0_20px_50px_rgba(0,0,0,0.3)]"
            />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col space-y-6 text-center lg:text-left items-center lg:items-start order-1 lg:order-2"
        >
          <div className="space-y-2">
            <h1 className="text-5xl md:text-8xl font-black text-white tracking-tighter leading-none uppercase drop-shadow-lg">
              DIGITAL <br />
              <span className="text-slate-900/80">CANTO</span>
            </h1>
            <div className="h-1.5 w-96 bg-white rounded-full mx-auto lg:mx-0"></div>
          </div>

          <h2 className="text-lg md:text-2xl font-bold text-white/90 tracking-[0.3em] uppercase">
            Impact<span className="text-slate-900">|</span> Optimize <span className="text-slate-900">|</span> Convert
          </h2>

          <p className="text-white/80 max-w-md text-sm md:text-lg leading-relaxed font-medium">
            We craft strategies that boost your brand, drive leads, increase sales, and create lasting digital impact for your business.
          </p>
        </motion.div>

      </div>
    </section>
  );
}

export default Intro;